import styled, { css } from '@app/styled';
import { oneLineEllipsis } from '@app/styles';
import { color, modifier, spacing, typography, zIndex } from '@app/theme';

export const Container = styled.div<{ $headerHeight: number }>`
    min-height: ${({ $headerHeight }) => `${$headerHeight}px`};
`;

export const HeaderContent = styled.div<{ $staticEnabled: boolean }>`
    position: fixed;
    background-color: ${color('custom.background.primary')};
    top: 0;
    left: 95px;
    right: 32px;
    z-index: ${zIndex('stickyForTwigViews')};

    padding-top: ${spacing(5)};
    padding-left: 30px;
    padding-right: 30px;
    margin-left: -30px;
    margin-right: -30px;
    border-bottom: 1px solid ${color('custom.border.primary')};

    ${modifier(
        '$staticEnabled',
        css`
            z-index: ${zIndex('auto')};
            position: relative;
            top: inherit;
            left: 0;
            right: 0;
            padding-top: 0;
            box-shadow: none;
        `,
    )}
`;

export const BreadcrumbsContainer = styled.div`
    display: flex;
    margin-bottom: ${spacing(1)};
    width: 100%;
    align-items: center;
`;

export const Breadcrumbs = styled.nav`
    ${oneLineEllipsis};
    ${typography('custom.description')};
    margin-right: ${spacing(1)};
    max-width: 90%;

    // Prevent inline children from wrapping so text-overflow works correctly
    & > * {
        white-space: nowrap;
    }
`;
